export default __webpack_public_path__ + "dist/css/style.css";